export const scrollPageToTop = () => {
  if (window) {
    window.scrollBy({ left: 0, top: window.scrollY * -1, behavior: 'smooth' });
  }
};
